import styled from "styled-components";
import Image from "next/image";

const PartnerContainer = styled.div`
    text-align: center;
    color: #fff;
`;

type PartnerProps = {
    title: string;
    logo: any;
    srcSet?: [string, string][];
};

const Partner = ({ title, logo }: PartnerProps) => {
    const getImageProps = () => {
        // if (!srcSet) {
        return { src: logo };
        // }

        // const srcset = srcSet.map(([imageFile]) => imageFile).join(", ");
        // const sizes = srcSet.map(([, size]) => size).join(", ");
        //
        // return { srcSet: srcset, sizes, src: logo };
    };

    return (
        <PartnerContainer>
            <div className="media">
                <Image {...getImageProps()} alt={title} />
            </div>
        </PartnerContainer>
    );
};

export default Partner;
